export const $color = {
	success: '#28a745',
	warning: '#ffc107',
	error: '#ff4d4d',
};
